import tipjarIDL from './tipjar.did.js';
import cronicIDL from './cronics.did.js';
var API = extjs.connect().canister("nraos-xaaaa-aaaah-qadqa-cai", tipjarIDL);
var CRONICS = extjs.connect().canister("e3izy-jiaaa-aaaah-qacbq-cai", cronicIDL);
var MINAMOUNT = 20000000;
var rem;
var currentAddress = false, currentTipAddress = false, tokenId = false, intv;
const getAvailable = async () => {
  var r = await CRONICS.getSold();
  rem = 5000 - r;
  if (rem <= 0) {
    $('#available').hide();
    $('#unavailable').show();
  }else {
    $('#available>span').html(rem);
    $('#available').show();
  }
};
const checkBalance = async () => {
  if (!currentTipAddress) return;
  if (!intv) return;
  var r = await extjs.connect().canister("ryjl3-tyaaa-aaaaa-aaaba-cai").account_balance_dfx({account:currentTipAddress});
  var donation = Number(r.e8s) / (10**8);
  if (donation == 0) {
    $('#balance').html("No funds have been donated yet");
  } else {
    API.confirmDonation(currentAddress);
    $('#balance').html("You have donated " + donation + " ICP - We thank you so much for the support!");
    if (Number(r.e8s) >= MINAMOUNT) {
      $('#claimGift').show();      
    };
  }
};
const copyToClipboard = function(text) {
if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text); 

} else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
    } finally {
        document.body.removeChild(textarea);
    }
}}
$('document').ready(function(){
  //setInterval(getAvailable, 2*1000);
  //getAvailable();
  $('#tipAddressCopy').click(() => {
    copyToClipboard(currentTipAddress);
    alert("Copied");
  });
   $('#tokenIdCopy').click(() => {
    copyToClipboard(tokenId);
    alert("Copied");
  });
  $('button#claimGift').click(() => {
    tokenId = false;
    $('button#claimGift').html("Loading...");
    $('button#claimGift').attr("disabled", true);
    API.claimFreeGift(currentAddress).then(r => {
      if (r.hasOwnProperty("err")) {
        alert("There was an error: " + r.err);
        $('button#claimGift').html("Retreive Free Gift");
        $('button#claimGift').attr("disabled", false);
      } else {
        console.log(r);
        $('button#claimGift').html("Retreive Free Gift");
        $('button#claimGift').attr("disabled", false);
        $('button#claimGift').hide();
        tokenId = extjs.encodeTokenId("e3izy-jiaaa-aaaah-qacbq-cai", r.ok);
        var imgSrc = "https://e3izy-jiaaa-aaaah-qacbq-cai.raw.ic0.app/?tokenid="+tokenId;
        $("#tokenid>span").html(tokenId);
        $('#cronicImg').attr('src', imgSrc);
        $("#gift").show();
        clearInterval(intv);
        intv = false;
      };
    });
  });  
  $('button#donate').click(() => {
    if (rem <= 0) {
      alert("Please be aware that there are no free NFT gifts available anymore");
    };
    $('#donation').hide();
    $('#claimGift').hide();
    $('#gift').hide();
    currentAddress = false;
    currentTipAddress = false;
    var address = $('#address').val().toString();
    if (address == "") return alert("Please enter an address");
    var addressBytes = extjs.fromHexString(address);
    if (addressBytes.length != 32) return alert("Please enter a valid address, not principal");
    var tipAddress = extjs.principalToAccountIdentifier("sensj-ihxp6-tyvl7-7zwvj-fr42h-7ojjp-n7kxk-z6tvo-vxykp-umhfk-wqe", addressBytes);
    currentAddress = address;
    currentTipAddress = tipAddress;
    $('#tipAddress>span').html(tipAddress);
    $('#balance').html("Loading donated balance...");
    $('#donation').show();
    intv = setInterval(checkBalance, 10*1000);
    checkBalance();
  });
});

window.API = API;
window.checkBalance = checkBalance;